import basicTemplate from './basicTemplate.twig';
import districtTemplate from './districtTemplate.twig';
import Utils from '../../common/scripts/utils';

export default class Objects {
    constructor(element) {
        this.button = element;
        this.parent = document.querySelector(`.${this.button.dataset.parent}`) || document.querySelector('#objects');
        this.url = this.button.dataset.ajax;
        this.lang = this.button.dataset.lang;
        this.page = 1;
        this.districts = this.button.classList.contains('j-districts');

        this.handleListener();
    }

    getData() {
        const that = this;

        Utils.send({
            lang: this.lang,
            page: this.page
        }, this.url, {
            success(respond) {
                if (that.districts) {
                    const buttonElement = that.button.parentElement;

                    buttonElement.remove();

                    respond.data.forEach((item) => {
                        that.parent.insertAdjacentHTML('beforeend', districtTemplate(item));
                    });
                    if (!respond.request.isLast) {
                        that.button.innerText = `Показать еще ${respond.request.cntMore} ЖК`;
                        that.parent.appendChild(buttonElement);
                    }
                } else {
                    respond.data.forEach((item) => {
                        that.parent.insertAdjacentHTML('beforeend', basicTemplate(item));
                    });

                    if (respond.request.isLast) {
                        that.button.style.display = 'none';
                    } else {
                        that.button.style.display = 'block';
                    }

                    that.page = that.page + 1;
                }
            },
            error(error) {
                console.error(`ошибка на сервере: ${error}`);
            }
        });
    }

    handleListener() {
        this.button.addEventListener('click', () => {
            return this.getData();
        });
    }
}
